import React from 'react';

const CategoriesPage = () => (
  <div>
    <h1>CategoriesPage</h1>
  </div>
);

export default CategoriesPage;
